export const UPDATE_ORDER= 'UPDATE_ORDER'
export const UPDATE_ORDER_SUCCESS= 'UPDATE_ORDER_SUCCESS'
export const UPDATE_ORDER_ERROR='UPDATE_ORDER_ERROR'

export const UpdateOrder= (data) => ({
    type: UPDATE_ORDER,
    payload: data
});